/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceTemplateParam {
    getFixupPrototypeFunction() { return ResourceTemplateParam.fixupPrototype; }

    static newInstance(model: Partial<ResourceTemplateParam>): ResourceTemplateParam {
        let obj = Object.assign(new ResourceTemplateParam(), model);
        ResourceTemplateParam.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceTemplateParam>): ResourceTemplateParam {
        if (!model) return null;
        return ResourceTemplateParam.newInstance(<ResourceTemplateParam> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceTemplateParam) {
        if (!obj) return;

        models.ResourceTemplateParam.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceTemplateParam): boolean {
        Object.setPrototypeOf(obj, ResourceTemplateParam.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Input name the template expects, for example InstanceId
     */
    name: string;

    /**
     * Dotted path in the inventory record the input is read from, for example summary_details.instancesSet.item.instanceId
     */
    ref: string;

}
